import { CoreDataSecurityMonitorsName } from './name';
import { createPostAsyncSlice } from '@sonar-software/xuder';
import { getCoreDataSecurityMonitorsAllSlice } from './all/get';
import { getCoreDataSecurityMonitorsByApplicationSlice } from './application/get';
import { getCoreDataSecurityMonitorsSlice } from './get';
import { postDataSecurityMonitor } from '@api/data-security';

export const postCoreDataSecurityMonitorsSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [
			getCoreDataSecurityMonitorsSlice.asyncActionCreators.repeatGetCoreDataSecurityMonitors,
			getCoreDataSecurityMonitorsAllSlice.asyncActionCreators.repeatGetCoreDataSecurityMonitorsAll,
			// eslint-disable-next-line max-len
			getCoreDataSecurityMonitorsByApplicationSlice.asyncActionCreators.repeatGetCoreDataSecurityMonitorsByApplication
		]
	},
	name: CoreDataSecurityMonitorsName,
	receive: false,
	request: true,
	requestHandler: postDataSecurityMonitor
});
